import BookingDetailsContent from './BookingDetailsContent';

const TourBookingDetails = () => <BookingDetailsContent />;

export default TourBookingDetails;
